<template>
  <div class="modal_small_text">
    <div>
      <v-row>
        <v-col>
          <VTextField
            v-model="infos.name[selectedLang]"
            outlined
            :label="$t('forms.labels.name')"
            data-cy="chart-name"
            :rules="{ min: 1, max: 200 }"
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <VAutocomplete
            v-model="infos.selectedAnalysis"
            itemValue="id"
            outlined
            :label="$t('forms.labels.analysis')"
            :items="getAnalysisTypeList"
            multiple
            :filter="null"
            :loading="loading"
            :rules="{ required: true }"
            data-cy="chart-analysis"
            @change="updateData"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    name: 'Description',
    components: {
        VTextField,
        VAutocomplete,
    },
    props: {
        chart: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            infos: {
                selectedAnalysis: [],
                name: {},
            },
            analysisTypeList: [],
            loading: false,
        };
    },

    computed: {
        ...mapGetters([
            'userLang',
            'lang',
            'teamMainLang',
            'selectedLang',
        ]),
        getAnalysisTypeList() {
            return this.analysisTypeList.map(aT => ({
                id: aT.id,
                name: aT.name[this.userLang] || aT.name[this.teamMainLang],
            }));
        },
    },


    async created() {
        await this.getAnalysisType();
        if (this.isEdition) {
            this.infos = { ...this.chart };
        }
    },


    methods: {
        async getAnalysisType() {
            this.loading = true;
            const { data } = await this.$rq.getAnalysisTypes({ pagination: false });
            this.analysisTypeList = data.types;
            this.loading = false;
        },
        updateData() {
            this.$emit('sendData', this.infos);
        },
    },
};
</script>

<style lang="scss" scoped>

    .formula-hint {
        position: relative;
    }
    .addButton{
         margin-top:75px;
    }
</style>
